import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Form } from '@anytag/shared-atoms';
import { TextSearchField } from '../rhf-fields';
import { KeywordFilterFormValues } from './types';

export interface TemplateProps {
  placeholder?: string;
  onSubmit?: () => void;
  children?: ReactNode;
}
export const Template = ({ onSubmit, children, placeholder }: TemplateProps) => {
  const { t } = useTranslation();

  return (
    <Form.Fields>
      <TextSearchField<keyof KeywordFilterFormValues>
        name="keyword"
        onSubmit={onSubmit}
        placeholder={placeholder ?? t<string>('Search.keywords')}
      />

      {children}
    </Form.Fields>
  );
};
